import type * as lazyIndex from "./lazyIndex";
import { SendFeedbackContainer } from "owa-addins-core";
import { LazyImport, LazyModule } from "owa-bundling";
import sendFeedbackCallback from "./utils/createSendFeedbackCallback";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "AddinsMail" */ "./lazyIndex"), { name: "AddinsMail" });

export const lazyCreateMailReadAdapter: LazyImport<typeof lazyIndex.createMailReadAdapter, typeof lazyModule> = new LazyImport(lazyModule, m => m.createMailReadAdapter);
export const lazyCreateMailComposeAdapter: LazyImport<typeof lazyIndex.createMailComposeAdapter, typeof lazyModule> = new LazyImport(lazyModule, m => m.createMailComposeAdapter);
export const lazyCreateMultiSelectAdapter: LazyImport<typeof lazyIndex.createMultiSelectAdapter, typeof lazyModule> = new LazyImport(lazyModule, m => m.createMultiSelectAdapter);
export const lazyCreateDecryptionAdapter: LazyImport<typeof lazyIndex.createDecryptionAdapter, typeof lazyModule> = new LazyImport(lazyModule, m => m.createDecryptionAdapter);

SendFeedbackContainer.sendFeedback = sendFeedbackCallback;

// Export hooks
export { useAddins } from "./hooks/useAddins";
